import { render, staticRenderFns } from "./MainLoader.vue?vue&type=template&id=ed873f28&scoped=true&"
import script from "./MainLoader.vue?vue&type=script&lang=ts&"
export * from "./MainLoader.vue?vue&type=script&lang=ts&"
import style0 from "./MainLoader.vue?vue&type=style&index=0&id=ed873f28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed873f28",
  null
  
)

export default component.exports